export default __webpack_public_path__ + "static/media/amnd.ddb816a7.jpg";